import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import ShippingServiceList from "./lists/ShippingServiceList";
import ShippingServiceForm from "./forms/ShippingServiceForm";
import BoxEditor from "./BoxEditor";
import { withSnackbar } from 'notistack';

class ShippingServiceEditor extends React.Component {

    state = {
        moneyrepository: null,
        shippingFailed: false,
        newButton: false,
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    deleteForm = async (event) => {
        await this.props.deleteForm(event);
        this.list && this.list.refresh();
        this.editor && this.editor.hide();
    }

    render() {
        const props = {...this.props};
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        
        let disabled = (props.values.state || "0") + "" !== "0";

        /*props.filter = Array.isArray(props.filter) ? [...props.filter] : (!props.filter ? [props.filter] : []);
        if (props.businessComponent) {
            props.filter = [
                ...props.filter, ...[
                    {
                        field: "client_component",
                        value: props.businessComponent.componentConfig.componentname
                    }, {
                        field: "client_component_id",
                        value: props.businessComponent.values[props.businessComponent.componentConfig.idfield]
                    }
                ]
            ];
        } else if(props.pos !== undefined) {
            props.filter = [
                ...props.filter, ...[
                    {
                        field: "serviceprovider_type",
                        value: "personalpickup"
                    },
                    {
                        field: "location",
                        value: props.pos.location.id
                    },
                ]
            ];
        }*/

        disabled = disabled || this.props.isLoading;

        return (
            <Fragment>
                <List
                    {...props}
                    collapsed={props.collapsed || false}
                    theme="default"
                    header="Szállítások"
                >
                    <ShippingServiceList
                        ref={(el) => this.list = el}
                        {...props}
                        onLoadCompleted={(response) => {
                            this.setState({newButton: parseInt(response.fullcount || "0") === 0});
                        }}
                        loadForm={this.loadForm}
                    />
                </List>
                <Editor
                    {...props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={props.pos !== undefined ? "Csomag átadás/Személyes átvétel adatai" : "Szállítás adatai"}
                >
                    {Object.keys(props.values).length !== 0 && <ShippingServiceForm
                        ref={(form) => this.form = form}
                        {...props}
                        setMoneyRepository={(moneyrepository) => this.setState({moneyrepository})}
                        moneyrepository={this.state.moneyrepository}
                        shippingCompleted={this.shippingCompleted}
                        disabled={disabled}
                    />}
                </Editor>
            </Fragment>
        );
    }
}

export default withSnackbar(createEditor({
    componentName: "ShippingService",
    WrappedComponent: ShippingServiceEditor,
    props: {
        componentActions: (action, data, params) => {
            data = {...data};
            delete data.methodname;
            return {action,data,params};
        }
    }
}));
